import { QsMeta } from "kz-ui-sdk";

export const RECENT_GAME_QUERY_PARAMS: QsMeta = {
  limit: 20,
  offset: 0,
};
